/*
 * @Descripttion:
 * @version:
 * @Author: zhengyangyang
 * @Date: 2022-12-28 09:35:31
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-12-14 15:25:43
 */
import { get, post } from '../axios'
const formData = {
	// 录入的表单展示接口
	getNodeData: (params) => get(`/web/preview/previewEntry/${params}`),
	// 提交表单
	saveOrUpdateFormData: params => post('/web/formData/saveOrUpdateFormData', params),
	// 驳回原因
	formReject: params => post(`/web/subjectForm/formPostil`, params),
	// 模板录入接口：
	saveOrUpdateTemplateFormData: params => post(`/web/templateFormData/saveOrUpdateFormData/${params.sendCode}`, params),
	getFormPreviewEntry: params => post(`/web/template/preview/previewEntry`, params),
	// 更新成完成
	updateToFinished: params => post(`/web/subjectForm/updateToFinished`, params),
	// 取消完成
	unlockForm: params => post(`/web/subjectForm/unlockForm/${params}`)
}
export default formData